export enum AlarmType {
	FIRE = 'Fire Alarm',
	WATER_LEAK = 'Water Leak Alarm',
	TEMPERATURE = 'Temperature Alarm',
	PANIC_BUTTON = 'Panic Button',
	PANIC_BUTTON_ALARM = 'Panic Button Alarm',
	INTRUDER = 'Intruder Alarm'
}
